import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeUnderscore',
})
export class RemoveUnderscorePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    // Remove underscores and convert to lowercase
    return String(value).replace(/_/g, ' ').toLowerCase();
  }
}
